import React from 'react';
import { TypedMemo } from '../../../common/types';
import { LoadingView } from '../../../common/views/LoadingView';
import { useAccountId } from '../../../../redux/slices/appInfo/hooks';
import { SoundProfileScreen } from './SoundProfileScreen';

/** The route `/outreach/profile` (design outreach b1). */
const SoundProfileViewComponent: React.FC = () => {
  const accountId = useAccountId();
  if (accountId === null) {
    return <LoadingView />;
  }
  return <SoundProfileScreen accountId={accountId} />;
};

export const SoundProfileView = TypedMemo(SoundProfileViewComponent);
